{
  "id": "peanut",
  "name": "Peanut",
  "species": "Arachis hypogaea",
  "ploidy": 4,
  "assembly": "Tifrunner gnm1 KYV3 / gnm2 J5K5 (Arahy.01-Arahy.10 = A subgenome, Arahy.11-Arahy.20 = B subgenome; gnm2 NCBI seq-name arahy.Tifrunner.gnm2.chrNN; A01-A10/B01-B10 and Aradu./Araip. tokens are not mapped)",
  "chromosomes": [
    "Arahy.01",
    "Arahy.02",
    "Arahy.03",
    "Arahy.04",
    "Arahy.05",
    "Arahy.06",
    "Arahy.07",
    "Arahy.08",
    "Arahy.09",
    "Arahy.10",
    "Arahy.11",
    "Arahy.12",
    "Arahy.13",
    "Arahy.14",
    "Arahy.15",
    "Arahy.16",
    "Arahy.17",
    "Arahy.18",
    "Arahy.19",
    "Arahy.20"
  ],
  "keys": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20"
  ],
  "pattern": "^(?:(?:arahy\\.tifrunner\\.gnm[12]\\.)?(?:arahy\\.|chr)|chromosome)?[_\\s-]?0*([1-9]|1[0-9]|20)$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/003/086/295/GCF_003086295.2_arahy.Tifrunner.gnm1.KYV3/GCF_003086295.2_arahy.Tifrunner.gnm1.KYV3_assembly_report.txt",
    "https://hgdownload.soe.ucsc.edu/hubs/GCF/003/086/295/GCF_003086295.3/GCF_003086295.3_assembly_report.txt",
    "https://rest.ensembl.org/info/assembly/arachis_hypogaea?content-type=application/json",
    "https://data.legumeinfo.org/Arachis/hypogaea/genomes/Tifrunner.gnm1.KYV3/README.Tifrunner.gnm1.KYV3.yml",
    "https://data.legumeinfo.org/Arachis/hypogaea/genomes/Tifrunner.gnm2.J5K5/README.Tifrunner.gnm2.J5K5.yml",
    "https://www.osti.gov/pages/servlets/purl/2479207",
    "http://oar.icrisat.org/11189/1/The%20genome%20of%20cultivated%20peanut%20provides%20insight%20into%20legume%20karyotypes%2C%20polyploid%20evolution%20and%20crop%20domestication.pdf",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC7822046/"
  ]
}
